export default [
  {
		path: '/dataList/authManagement',
		component: (resolve) => require(['../index.vue'], resolve),
		meta: {
			title: '角色权限管理',
			keepAlive: false,
		},
  },
  {
    path: '/dataList/authManagemented',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
      title: '角色权限管理',
      authLogin: true
    }
  }, {
    path: '/dataList/authDetails',
    component: resolve => require(['../details.vue'], resolve),
    meta: {
      title: '角色权限详情',
      authLogin: true
    }
  }, {
    path: '/dataList/edit',
    component: resolve => require(['../edit.vue'], resolve),
    meta: {
      title: '角色权限编辑',
      authLogin: true
    }
  }, {
    path: '/dataList/add',
    component: resolve => require(['../add.vue'], resolve),
    meta: {
      title: '角色权限新增',
      authLogin: true
    }
  }
]